import React from 'react';

import { Language, SeatsioSeatingChart } from '@seatsio/seatsio-react';

export const EventManagerElement: React.FC<{
  workspaceKey: string;
  eventId: string;
  language: Language;
}> = ({ workspaceKey, eventId, language }) => {
  return (
    <SeatsioSeatingChart
      session={'none'}
      showFullScreenButton={false}
      language={language}
      workspaceKey={workspaceKey}
      event={eventId}
      region="eu"
      mode={'static'}
    />
  );
};
